import {Utilities} from '@shared/utilities/utilities.model';
import {Parts} from '../../authority-op/models/quotation.model';
import { PartsOrderStates } from './enums.model';

export class PartsOrderModel {
    actions;
    amDiscountHigh;
    amDiscountLow;
    amDiscountMedium;
    brand: string;
    brandLabel: string;
    chassis: string;
    commodityAddress: string;
    commodityEmail: string;
    commodityName: string;
    commodityPhone: string;
    createdAt: { nano: number, epochSecond: number };
    dealerId: string;
    engineCode;
    externalOrderNumber: number;
    id: string;
    matriculation;
    model: string;
    modelLabel: string;
    oeDiscountHigh: number;
    oeDiscountLow: number;
    oeDiscountMedium: number;
    orderNumber: number;
    orderNumberPrefix: string;
    parts: Parts[];
    plate: string;
    priority: number;
    quotationId: string;
    status: string;
    type: string;
    version: string;
    versionLabel: string;
    archived: boolean;

    constructor(model?: PartsOrderRequestModel) {
        if (!Utilities.isVoid(model)) {
            this.actions = model.actions;
            this.amDiscountHigh = model.am_discount_high;
            this.amDiscountLow = model.am_discount_low;
            this.amDiscountMedium = model.am_discount_medium;
            this.brand = model.brand;
            this.brandLabel = model.brand_label;
            this.chassis = model.chassis;
            this.commodityAddress = model.commodity_address;
            this.commodityEmail = model.commodity_email;
            this.commodityName = model.commodity_name;
            this.commodityPhone = model.commodity_phone;
            this.createdAt = model.created_at;
            this.dealerId = model.dealer_id;
            this.engineCode = model.engine_code;
            this.externalOrderNumber = model.external_order_number;
            this.id = model.id;
            this.matriculation = model.matriculation;
            this.model = model.model;
            this.modelLabel = model.model_label;
            this.oeDiscountHigh = model.oe_discount_high;
            this.oeDiscountLow = model.oe_discount_low;
            this.oeDiscountMedium = model.oe_discount_medium;
            this.orderNumber = model.order_number;
            this.orderNumberPrefix = model.order_number_prefix;
            this.parts = model.parts;
            this.plate = model.plate;
            this.priority = model.priority;
            this.quotationId = model.quotation_id;
            this.status = model.status;
            this.type = model.type;
            this.version = model.version;
            this.versionLabel = model.version_label;
            this.archived = model.archived;
        }
    }

	setArchived(archived: boolean): void {
		this.archived = archived;
	}

	/**
	 * Indica se l'intervento è chiuso-archiviato
	 * Le pratiche associate all'intervento archiviato non possono essere canalizzate
	 * 
	 * @returns {boolean}
	 */
	isArchived(): boolean {
		// return true;
		return !!this.archived;
	}

	/**
	 * Restituisce la lista degli stati finali dell'entità
	 * 
	 * @returns {PartsOrderStates[]}
	 */
    static getFinalStatusList(): PartsOrderStates[] {
        return [ PartsOrderStates.CANCELED, PartsOrderStates.CLOSED, PartsOrderStates.CANCELED_BY_REJECTION ];
    }
}

export class PartsOrderRequestModel {
    actions;
    am_discount_high;
    am_discount_low;
    am_discount_medium;
    brand: string;
    brand_label: string;
    chassis: string;
    commodity_address: string;
    commodity_email: string;
    commodity_name: string;
    commodity_phone: string;
    created_at: { nano: number, epochSecond: number };
    dealer_id: string;
    engine_code;
    external_order_number: number;
    id: string;
    matriculation;
    model: string;
    model_label: string;
    oe_discount_high: number;
    oe_discount_low: number;
    oe_discount_medium: number;
    order_number: number;
    order_number_prefix: string;
    parts: Parts[];
    plate: string;
    priority: number;
    quotation_id: string;
    status: string;
    type: string;
    version: string;
    version_label: string;
    archived: boolean;

    constructor(model?: PartsOrderModel) {
        if (!Utilities.isVoid(model)) {
            this.actions = model.actions;
            this.am_discount_high = model.amDiscountHigh;
            this.am_discount_low = model.amDiscountLow;
            this.am_discount_medium = model.amDiscountMedium;
            this.brand = model.brand;
            this.brand_label = model.brandLabel;
            this.chassis = model.chassis;
            this.commodity_address = model.commodityAddress;
            this.commodity_email = model.commodityEmail;
            this.commodity_name = model.commodityName;
            this.commodity_phone = model.commodityPhone;
            this.created_at = model.createdAt;
            this.dealer_id = model.dealerId;
            this.engine_code = model.engineCode;
            this.external_order_number = model.externalOrderNumber;
            this.id = model.id;
            this.matriculation = model.matriculation;
            this.model = model.model;
            this.model_label = model.modelLabel;
            this.oe_discount_high = model.oeDiscountHigh;
            this.oe_discount_low = model.oeDiscountLow;
            this.oe_discount_medium = model.oeDiscountMedium;
            this.order_number = model.orderNumber;
            this.order_number_prefix = model.orderNumberPrefix;
            this.parts = model.parts;
            this.plate = model.plate;
            this.priority = model.priority;
            this.quotation_id = model.quotationId;
            this.status = model.status;
            this.type = model.type;
            this.version = model.version;
            this.version_label = model.versionLabel;
            this.archived = model.archived;
        }
    }
}

export class PartsOrderDetailModel {
    id: string;
    partsOrder: PartsOrderModel;

    constructor(model?: PartsOrderDetailRequestModel) {
        if (!Utilities.isVoid(model)) {
            this.id = model.id;
            this.partsOrder = new PartsOrderModel(model.parts_order);
        }
    }
}

export class PartsOrderDetailRequestModel {
    id: string;
    parts_order: PartsOrderRequestModel;

    constructor(model?: PartsOrderDetailModel) {
        if (!Utilities.isVoid(model)) {
            this.id = model.id;
            this.parts_order = new PartsOrderRequestModel(model.partsOrder);
        }
    }
}


export enum EPartsOrderStates {
    NEW                   = 'NEW',
    IN_PROGRESS           = 'IN_PROGRESS',
    CLOSED                = 'CLOSED',
    CANCELED              = 'CANCELED',
    CANCELED_BY_REJECTION = 'CANCELED_BY_REJECTION',
}
